<template>
  <div>
    <p v-bind:class="['intro-text', {
                 'w-controls' : withControls
               }]" data-aos="fade-in"><span v-html="text"></span></p>
    <p v-if="subText" data-aos="fade-in"><span v-html="subText"></span></p>
  </div>
</template>

<script>
  export default {
    name: 'IntroText',
    props: {
      text: {
        type: String,
        default: null
      },
      subText: {
        type: String,
        default: null
      },
      withControls: {
        type: Boolean,
        default: true
      }
    }
  }
</script>
